<template>
  <div>
    <form-alert
      :type="alertText.type"
      :message="alertText.message"
      @close="closeFormAlert"
    />

    <h2>Carta de nomeação</h2>
    <p>
      {{
        statusNomeado == "SEM_NOMEACAO"
          ? "Opcional para bloqueio do tomador sem demanda em sua carteira"
          : ""
      }}
    </p>
    <anexo-list-component
      id="carta_nomeacao"
      :documentosSolicitados.sync="documentos"
      :classColuna="'xs12'"
      :isCartaNomeacao="true"
      @send="setUpdateDocumentos"
      @setDocumentosModel="this.enviarCartaNomeacao"
    ></anexo-list-component>
  </div>
</template>

<script lang="js">
import { eventBus } from "../main";
import ViewMixin from "@/mixins/ViewMixin";

export default {
  name: "TomadorCartaNomeacao",
  mixins: [ViewMixin],
  data() {
    return {
      alertText: {},
      documentos: [
        {
          categoria: "Carta de Nomeação",
          listagem: [
            {
              nome: "Carta de Nomeação",
              id: 0,
              multiplo: false,
            },
          ],
        },
      ],
    };
  },
  props: ["idTomador", "statusNomeado"],
  methods: {
    async enviarCartaNomeacao(dataDocumentos) {
      if (dataDocumentos && dataDocumentos.length) {
        this.showLoadingIndicator();

        let payload = {
          documentos: dataDocumentos,
          id_tomador: this.idTomador,
          nome: "carta-nomeacao.pdf",
        };
        try {
          await this.$store.dispatch("UPLOAD_CARTA_NOMEACAO", payload);
        } catch (e) {
          this.showUploadFailedPopup();
          console.warn(e);
          return;
        } finally {
          this.hideLoadingIndicator();
        }
        this.$emit("complete");
      }
    },

    showUploadFailedPopup() {
      this.$store.commit("SET_ALERT_TEXT", {
        type: "error",
        message: "Houve algo de errado com upload de arquivo!",
      });
      this.alertText = this.handleAlertText();
    },

    setUpdateDocumentos(data) {
      this.documentos = data;
      this.$forceUpdate();

      eventBus.$emit("setModelAnexos");
    },
  },
};
</script>

<style lang="css" scoped>
.v-card__title {
  background-color: #efefef;
  font-size: 14px;
  font-weight: bolder;
  color: #191737;
  margin-bottom: 20px;
}
</style>


// WEBPACK FOOTER //
// ./src/components/TomadorCartaNomeacao.vue